import React, {
    useState,
    forwardRef,
    useImperativeHandle,
} from "react";
import {Popup, PopupAnchor} from "./_layout/popups/Popup";
import {ColleagueInfoPanel} from "./ColleagueInfoPanel";
import {User} from "../types/users";


export type ColleagueInfoPopupHandle = {
    openAtElement: (el: HTMLElement, data: any) => void;
    close: () => void;
};


export const ColleagueInfoPopup = forwardRef<ColleagueInfoPopupHandle>(
    (_, ref) => {
        const [open, setOpen] = useState(false);
        const [anchor, setAnchor] = useState<PopupAnchor>(null);
        const [data, setData] = useState<User | null>(null);

        useImperativeHandle(ref, () => ({
            openAtElement: (el: HTMLElement, d: any) => {
                setAnchor({type: "element", el});
                setData(d);
                setOpen(true);
            },
            close: () => setOpen(false),
        }));

        return (
            <Popup
                open={open}
                onClose={() => setOpen(false)}
                anchor={anchor}
                placement="bottom-start"
                className="min-w-[260px]"
                role="menu"
            >
                {data && <ColleagueInfoPanel user={data} />}
            </Popup>
        );
    }
);
